import CardWrapper from "components/Common/CardWrapper";
import {
  lightLogo, mainLogo, footerLogo, clientName
} from "content";
import { useTranslation, withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Container } from "reactstrap";

const ForexFooter = (props) => {
  const { layoutMode } = useSelector((state) => ({
    layoutMode: state.Layout.layoutMode,
  }));
  const { t } = useTranslation();
  return (
    <Container className="my-4">
      <CardWrapper className="px-5 py-4 shadow glass-card" style={{
        background: layoutMode === "dark" ? "#1e1e2f" : "#fff",
      }}>
        <p className="text-secondary">
          {t("High Risk Investment Warning")}
        </p>
        <hr className="my-4 text-secondary"/>
        <span>&copy; {props.t("Copyright")} {new Date().getFullYear()} <img src={footerLogo} alt="Logo" height="40"/>, {clientName} {props.t("All rights reserved")}.</span>
      </CardWrapper>
    </Container>
  );
};

export default withTranslation()(ForexFooter);